'use strict';

goog.provide("Ntry.SpaceShip");

goog.require("Ntry.STATIC");

Ntry.SpaceShip = function(spaceShip) {
    this.direction = Ntry.STATIC.EAST;
};

Ntry.SpaceShip.prototype.type =
    Ntry.STATIC.SPACE_SHIP;
